const ROLES = {
  UPDATE_ROLES: 'UPDATE_ROLES',
  SET_VIEWING_AS_ADMIN: 'SET_VIEWING_AS_ADMIN',
  SET_VIEWING_AS_USER: 'SET_VIEWING_AS_USER'
}

export default ROLES
